import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { AlertModule, ComponentsModule } from '@ed---interne/ng-uui-components';

import { SidenavComponent } from '../../shared/components/sidenav/sidenav.component';
import { MainComponent } from './main.component';
import { HomeComponent } from './home/home.component';
import { EnedisComponent } from './enedis/components/dashboard/enedis-dashboard.component';
import { AccountComponent } from './settings/account/account.component';
import { AccountPasswordEditComponent } from './settings/edit-password/account-password-edit.component';

import { UsersComponent } from '../admin/users/users.component';

import { SkeletonListComponent } from '../../shared/components/skeleton-list/skeleton-list.component';

import { CoreModule } from '../../core/core.module';
import { SharedModule } from '../../shared/shared.module';
import { EdTableModule } from '../../shared/components/ed-table/ed-table.module';
import { EdModalConfirmModule } from '../../shared/components/modals/ed-modal-confirm/ed-modal-confirm.module';

import { InfiniteScrollDirective } from '../../shared/directives/infinite-scroll.directive';

import { MatMenuModule } from '@angular/material/menu';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { OrganizationComponent } from '../admin/organization/organization.component';
import { EnedisSearchComponent } from './enedis/components/search/enedis-search.component';
import { EnedisAccessRightCreateComponent } from './enedis/components/dashboard/access-right-create/enedis-access-right-create.component';
import { EnedisMeterComponent } from './enedis/components/meter/enedis-meter.component';
import { EnedisMeterConsumptionComponent } from './enedis/components/meter/consumption/enedis-meter-consumption.component';
import { EnedisMeterGeneralComponent } from './enedis/components/meter/general/enedis-meter-general.component';
import { EnedisMeterPowerCurveComponent } from './enedis/components/meter/power-curve/enedis-meter-power-curve.component';

import { EnedisConsentPageComponent } from './enedis/components/consent/consent-page/enedis-consent-page.component';
import { EnedisConsentRevokedComponent } from './enedis/components/consent/consent-revoked/enedis-consent-revoked.component';

import { GrdfComponent } from './grdf/components/dashboard/grdf-dashboard.component';
import { GrdfAccessRightCreateComponent } from './grdf/components/dashboard/access-right-create/grdf-access-right-create.component';
import { GrdfMeterGeneralComponent } from './grdf/components/meter/general/grdf-meter-general.component';
import { GrdfMeterComponent } from './grdf/components/meter/grdf-meter.component';
import { GrdfMeterConsumptionComponent } from './grdf/components/meter/consumption/grdf-meter-consumption.component';

import { GrdfConsentPageComponent } from './grdf/components/consent/consent-page/grdf-consent-page.component';
import { GrdfConsentRevokedComponent } from './grdf/components/consent/consent-revoked/grdf-consent-revoked.component';

@NgModule({
    declarations: [
        MainComponent,
        SidenavComponent,
        HomeComponent,
        EnedisComponent,
        EnedisMeterComponent,
        EnedisMeterConsumptionComponent,
        EnedisMeterPowerCurveComponent,
        EnedisMeterGeneralComponent,
        EnedisSearchComponent,
        EnedisAccessRightCreateComponent,
        EnedisConsentPageComponent,
        EnedisConsentRevokedComponent,
        GrdfComponent,
        GrdfMeterComponent,
        GrdfMeterGeneralComponent,
        GrdfAccessRightCreateComponent,
        UsersComponent,
        AccountComponent,
        AccountPasswordEditComponent,
        OrganizationComponent,
        GrdfMeterConsumptionComponent,
        GrdfConsentPageComponent,
        GrdfConsentRevokedComponent,
    ],
    imports: [
        CommonModule,
        NgbModule,
        RouterModule,
        FormsModule,
        SharedModule,
        ComponentsModule,
        CoreModule,
        SkeletonListComponent,
        EdTableModule,
        EdModalConfirmModule,
        InfiniteScrollDirective,
        ReactiveFormsModule,
        MatMenuModule,
        MatExpansionModule,
        MatSidenavModule,
        MatTableModule,
        MatSortModule,
        AlertModule,
    ],
})
export class MainModule {}
